import axios from "axios";
import cacheService from "../cache/cacheService";

const BASE_URL = "https://learn.microsoft.com/api/catalog";
const TTL_TAXONOMY = 24 * 60 * 60 * 1000;
const TTL_CONTENT  =  1 * 60 * 60 * 1000;

const client = axios.create({ baseURL: BASE_URL, timeout: 30000 });

const rawFetch = async (params) => {
  const res = await client.get("/", { params: { locale: "en-us", ...params } });
  return res.data;
};

export const fetchTaxonomy = () =>
  cacheService.getOrFetch("taxonomy", () => rawFetch({ type: "levels,products,roles,subjects" }), TTL_TAXONOMY);

export const fetchModules = () =>
  cacheService.getOrFetch("modules", () => rawFetch({ type: "modules" }), TTL_CONTENT);

export const fetchLearningPaths = () =>
  cacheService.getOrFetch("learningPaths", () => rawFetch({ type: "learningPaths" }), TTL_CONTENT);

export const fetchAllContent = () =>
  cacheService.getOrFetch("allContent", () => rawFetch({ type: "modules,learningPaths" }), TTL_CONTENT);

export const refreshCache = () => {
  ["taxonomy","modules","learningPaths","allContent"].forEach(k => cacheService.remove(k));
};
